/**
 * Created by mukund on 7/17/15.
 */

'use strict';

angular.module('mediacloudApp')
    .controller('QuizzingController', function ($scope, $compile, $state, $stateParams, $rootScope, $filter, Principal, AssetService) {

        Principal.identity().then(function(account) {

            var logger = function(msg) {
                var active = false;

                if(active) {
                    console.log(msg);
                }
            }

            var assetId = $state.params.assetId;
            var collectionId = $state.params.collectionId;
            var collectionType = $state.params.collectionType;
            $scope.hasWritePermissions = false;

            $scope.quiz = {
                questions: [],
                settings: {
                    allowSkipping: false,
                    shuffleAnswers: false,
                    answerSubmissions: 0,
                    quizSubmissions: 0,
                    showFeedback: false,
                    showResults: false
                }
            }
            // $scope.quiz = {
            //     title: 'Skydiving 101',
            //     description: 'Skydiving is parachuting (jumping) from an airplane for fun. Skydiving can be done individually and with groups of people. Training is required. Unlike most paratroopers, skydivers often wait until they are low, before opening the parachute.',
            //     createdOn: '6/2/2024, 4:45 PM (EST)',
            //     createdBy: 'John Doe',
            //     lastEdited: '6/7/2024, 2:20 PM (EST)',
            //     parentAsset: 'The Art of Skydiving',
            //     questions: [
            //         {
            //             id: 1,
            //             title: 'Sem tortor et vel diam orci ac. Eget tristique sem non lacus eget non ullamcorper gravida dignissim?',
            //             time: '00:05',
            //             type: 'multiple-choice',
            //             answers: [
            //
            //             ]
            //         },
            //         {
            //             id: 2,
            //             title: 'Sem tortor et vel diam orci ac. Eget tristique sem non lacus eget non ullamcorper gravida dignissim?',
            //             time: '00:24',
            //             type: 'multiple-choice',
            //             answers: [
            //
            //             ]
            //         },
            //         {
            //             id: 3,
            //             title: 'Sem tortor et vel diam orci ac. Eget tristique sem non lacus eget non ullamcorper gravida dignissim?',
            //             time: '00:38',
            //             type: 'multiple-choice',
            //             answers: [
            //
            //             ]
            //         },
            //     ],
            //     settings: {
            //         allowSkipping: false,
            //         shuffleAnswers: false,
            //         answerSubmissions: 0,
            //         quizSubmissions: 0,
            //         showFeedback: false,
            //         showResults: false
            //     }
            // };

            var getAsset = function () {
                logger('getAsset');
                console.log('collectionId', collectionId)
                console.log('assetId', assetId)

                AssetService.GetAsset.get({cid: collectionId, aid: assetId}, function (asset) {
                    $scope.asset = asset;
                    // $scope.hasWritePermissions = asset.acl.indexOf('W') > -1;
                    // $scope.hasWritePermissions = false;
                    $scope.hasWritePermissions = true;
                });
            };

            getAsset();

            $scope.handleQuizDescriptionKeyDown = function(e) {
                if (e.key === "Tab" && !e.shiftKey) {
                    e.preventDefault();
                    $(".video-toolbar div:nth-child(1)").focus();
                }
            }

            $scope.handleAddQuestionButtonClick = function(e) {
                //show/hide menu
                $(e.target).parents(".add-question").find(".menu").toggle();
            }

            $scope.handleQuizNameKeyDown = function(e) {
                setTimeout(function(){
                    if($(e.target).val().trim() !== '') {
                        //enable add question btn
                        $(".add-question button").attr("disabled", false);
                        $(".add-question button").removeClass("disabled");
                        $(".quiz-metadata .title-container .title").text($(e.target).val());
                        $(".quiz-metadata .title-container .title").css('color', '#253042');
                    } else {
                        $(".add-question button").attr("disabled", true);
                        $(".add-question button").addClass("disabled");
                        $(".quiz-metadata .title-container .title").text('Untitled Quiz');
                        $(".quiz-metadata .title-container .title").css('color', '#67707E');
                    }
                }, 0)
            }

            $scope.handleAddMultipleChoiceClick = function() {
                $(".quiz-metadata-container").hide();
                $(".true-false-metadata-container").hide();
                $(".multi-select-metadata-container").hide();
                $(".numeric-metadata-container").hide();
                $(".multiple-choice-metadata-container").show();
                $(".menu").hide();

                setTimeout(function(){
                    $('.multiple-choice-metadata-container .question-title').focus();
                }, 100);
            }

            $scope.handleAddTrueFalseClick = function() {
                $(".quiz-metadata-container").hide();
                $(".multiple-choice-metadata-container").hide();
                $(".multi-select-metadata-container").hide();
                $(".numeric-metadata-container").hide();
                $(".true-false-metadata-container").show();
                $(".menu").hide();

                setTimeout(function(){
                    $('.true-false-metadata-container .question-title').focus();
                }, 100);
            }

            $scope.handleAddMultiSelectClick = function() {
                $(".quiz-metadata-container").hide();
                $(".multiple-choice-metadata-container").hide();
                $(".numeric-metadata-container").hide();
                $(".true-false-metadata-container").hide();
                $(".multi-select-metadata-container").show();
                $(".menu").hide();

                setTimeout(function(){
                    $('.multi-select-metadata-container .question-title').focus();
                }, 100);
            }

            $scope.handleAddNumericClick = function() {
                $(".quiz-metadata-container").hide();
                $(".multiple-choice-metadata-container").hide();
                $(".multi-select-metadata-container").hide();
                $(".true-false-metadata-container").hide();
                $(".numeric-metadata-container").show();
                $(".menu").hide();

                setTimeout(function(){
                    $('.numeric-metadata-container .question-title').focus();
                }, 100);
            }

            $scope.handleMultipleChoiceAddNewOptionClick = function() {
                var newOption = '<div class="answer-option">';
                newOption += '<div class="radio-button"></div>';
                newOption += '<div class="answer-container">';
                newOption += '<input required type="text" placeholder="Answer option goes here..." ng-keydown="handleAnswerInputKeyDown($event)">';
                newOption += "</div>";
                newOption += '<div role="button" data-toggle="modal" data-target="#answerFeedbackModal"  class="answer-comment" ng-click="handleQuestionAnswerFeedbackButtonClick(\'answer\')"></div>';
                newOption +=
                    '<div role="button" ng-click="handleDeleteQuestion($event)" class="trash-icon"></div>';

                var newOptionElement = angular.element(newOption);
                $compile(newOptionElement)($scope);

                if ($(".multiple-choice-metadata-container .questions .answer-option:last-child").length) {
                    $(".multiple-choice-metadata-container").find(".questions .answer-option:last-child").after(newOptionElement);
                } else {
                    $(".multiple-choice-metadata-container .questions .question-title-component").after(newOptionElement);
                }

                setTimeout(function () {
                    $(".multiple-choice-metadata-container .questions .answer-option:last-child input").focus();
                }, 100);

                if($('.multiple-choice-metadata-container .questions .answer-option').length > 1) {
                    $('.multiple-choice-metadata-container .buttons-container .save-question').attr('disabled', false);
                }
            }

            $scope.handleMultiselectAddNewOptionClick = function() {
                var newOption = '<div class="answer-option">';
                newOption += '<div class="checkbox"></div>';
                newOption += '<div class="answer-container">';
                newOption += '<input required type="text" placeholder="Answer option goes here..." ng-keydown="handleAnswerInputKeyDown($event)">';
                newOption += "</div>";
                newOption += '<div role="button" data-toggle="modal" data-target="#answerFeedbackModal"  class="answer-comment" ng-click="handleQuestionAnswerFeedbackButtonClick(\'answer\')"></div>';
                newOption +=
                    '<div role="button" ng-click="handleDeleteQuestion($event)" class="trash-icon"></div>';

                var newOptionElement = angular.element(newOption);
                $compile(newOptionElement)($scope);

                if (
                    $(".multi-select-metadata-container .questions .answer-option:last-child")
                        .length
                ) {
                    $(".multi-select-metadata-container")
                        .find(".questions .answer-option:last-child")
                        .after(newOptionElement);
                } else {
                    $(
                        ".multi-select-metadata-container .questions .question-title-component"
                    ).after(newOptionElement);
                }

                setTimeout(function () {
                    $(
                        ".multi-select-metadata-container .questions .answer-option:last-child input"
                    ).focus();
                }, 100);
            }

            $scope.handleDeleteQuestion = function(e) {
                logger('handleDeleteQuestion');
                $(e.target).parents(".answer-option").remove();

                if($('.multiple-choice-metadata-container .questions .answer-option').length < 2) {
                    $('.multiple-choice-metadata-container .buttons-container .save-question').attr('disabled', true);
                }
            }

            $scope.handleExpandAnswersClick = function(e, source) {
                //Expand
                if ($(e.target).hasClass("arrow-up-right-and-arrow-down-left")) {
                    $(e.target).removeClass("arrow-up-right-and-arrow-down-left");

                    setTimeout(function () {
                        $(e.target).addClass("arrow-down-left-and-arrow-up-right-to-center");

                        $('.video-player').css('max-height', '220px');

                        $("." + source + "-metadata-container .questions").css({
                            "overflow-y": "unset",
                            "min-height": "38vh",
                            "height": "unset"
                        });
                    }, 10);
                }

                //Collapse
                if ($(e.target).hasClass("arrow-down-left-and-arrow-up-right-to-center")) {
                    $(e.target).removeClass("arrow-down-left-and-arrow-up-right-to-center");
                    $(e.target).addClass("arrow-up-right-and-arrow-down-left");

                    $("." + source + "-metadata-container .questions").css({
                        height: "182px",
                        "overflow-y": "scroll",
                    });

                    $('.video-player').css('max-height', '');
                    $('.questions').css('height', '');
                    $('.questions').css('min-height', '');
                }
            }

            var getQuestionId = function() {
                if($scope.quiz.questions && $scope.quiz.questions.length) {
                    return $scope.quiz.questions.length + 1;
                }

                return 1;
            }

            $scope.handleMultipleChoiceSaveQuestionClick = function(e) {
                if (
                    $scope.validateQuestion(
                        $(e.target).parents(".question-form").find("input.question-title")
                    )
                ) {
                    var questionId = getQuestionId();

                    var question = {
                        id: questionId,
                        title: $('.multiple-choice-metadata-container input.question-title').val(),
                        time: $('.multiple-choice-metadata-container input.time').val(),
                        type: 'multiple-choice'
                    }

                    var answers = [];
                    $('.multiple-choice-metadata-container .answer-option').each(function(index, item) {
                        answers.push({
                            title: $(item).find('input[type=text]').val(),
                            feedback: '',
                        })
                    })

                    question.answers = answers;

                    if(!$scope.quiz.questions) $scope.quiz.questions = [];

                    $scope.quiz.questions.push(question);
                    $scope.resetQuestionForm("multiple-choice", e);

                    console.log('$scope.quiz', $scope.quiz)
                } else {
                    console.log("error");
                }
            }

            $scope.handleMultipleChoiceCancelClick = function(e) {
                $scope.resetQuestionForm("multiple-choice", e);
                $(".multiple-choice-metadata-container").hide();
                $(".quiz-metadata-container").show();
            }

            $scope.handleTrueFalseSaveQuestionClick = function(e) {
                if (
                    $scope.validateQuestion(
                        $(e.target).parents(".question-form").find("input.question-title")
                    )
                ) {
                    console.log("save");
                    var questionId = getQuestionId();

                    var question = {
                        id: questionId,
                        title: $('.true-false-metadata-container input.question-title').val(),
                        time: $('.true-false-metadata-container input.time').val(),
                        type: 'true-false'
                    }

                    var answers = [];
                    $('.true-false-metadata-container .answer-option').each(function(index, item) {
                        answers.push({
                            title: $(item).find('span.text-option').text(),
                            feedback: '',
                        })
                    })

                    question.answers = answers;

                    if(!$scope.quiz.questions) $scope.quiz.questions = [];

                    $scope.quiz.questions.push(question);
                    $scope.resetQuestionForm("true-false", e);

                    console.log('$scope.quiz', $scope.quiz)
                } else {
                    console.log("error");
                }
            }

            $scope.handleTrueFalseCancelClick = function(e) {
                $scope.resetQuestionForm("true-false", e);
                $(".true-false-metadata-container").hide();
                $(".quiz-metadata-container").show();
            }

            $scope.handleMultiselectSaveQuestionClick = function(e) {
                if (
                    $scope.validateQuestion(
                        $(e.target).parents(".question-form").find("input.question-title")
                    )
                ) {
                    var questionId = getQuestionId();

                    var question = {
                        id: questionId,
                        title: $('.multi-select-metadata-container input.question-title').val(),
                        time: $('.multi-select-metadata-container input.time').val(),
                        type: 'multi-select'
                    }

                    var answers = [];
                    $('.multi-select-metadata-container .answer-option').each(function(index, item) {
                        answers.push({
                            title: $(item).find('input[type=text]').val(),
                            feedback: '',
                        })
                    })

                    question.answers = answers;

                    if(!$scope.quiz.questions) $scope.quiz.questions = [];

                    $scope.quiz.questions.push(question);
                    $scope.resetQuestionForm("multi-select", e);

                    console.log('$scope.quiz', $scope.quiz)
                } else {
                    console.log("error");
                }
            }

            $scope.handleMultiselectCancelClick = function(e) {
                $scope.resetQuestionForm("multi-select", e);
                $(".multi-select-metadata-container").hide();
                $(".quiz-metadata-container").show();
            }

            $scope.handleNumericCancelClick = function(e) {
                $scope.resetQuestionForm("numeric", e);
                $(".numeric-metadata-container").hide();
                $(".quiz-metadata-container").show();
            }

            $scope.handleNumericSaveQuestionClick = function(e) {
                if (
                    $scope.validateQuestion(
                        $(e.target).parents(".question-form").find("input.question-title")
                    )
                ) {
                    var questionId = getQuestionId();

                    var question = {
                        id: questionId,
                        title: $('.numeric-metadata-container input.question-title').val(),
                        time: $('.numeric-metadata-container input.time').val(),
                        type: 'numeric'
                    }

                    var answers = [];
                    answers.push({
                        title: $('.numeric-metadata-container .answer-option input.number').val(),
                        feedback: '',
                    });

                    question.answers = answers;

                    if(!$scope.quiz.questions) $scope.quiz.questions = [];

                    $scope.quiz.questions.push(question);
                    $scope.resetQuestionForm("numeric", e);

                    console.log('$scope.quiz', $scope.quiz)
                } else {
                    console.log("error");
                }
            }

            $scope.resetQuestionForm = function(formType, e) {
                var questionTitleInput = $(e.target).parents('.question-form').find('input.question-title');

                $(questionTitleInput).val('');
                $(e.target).parents('.question-form').find('input.time').val('');
                hideQuestionFormErrorMessage(questionTitleInput);

                if (formType === "multiple-choice" || formType === "multi-select") {
                    $(e.target).parents('.question-form').find('.answer-option').each(function(index, item){

                        $('.answer-container input').val('');
                        $('.answer-container input').parent().css('background', '#f2f3f5');

                        if(index > 0) {
                           $(item).find('.trash-icon').click();
                        }
                    });
                }
            }

            $scope.handleNumericIncreaseClick = function(e) {
                var inputField = $(e.target).parents(".numeric-answer-component").find("input");
                var value = $(inputField).val();

                if (!isNaN(value)) {
                    value++;
                }

                $(inputField).val(value);
            }

            $scope.handleNumericDecreaseClick = function(e) {
                var inputField = $(e.target).parents(".numeric-answer-component").find("input");
                var value = $(inputField).val();

                if (!isNaN(value)) {
                    value--;
                }

                $(inputField).val(value);
            }

            $scope.handleQuestionTitleBlur = function(e) {
                $scope.validateQuestion(e.target);
            }

            $scope.validateQuestion = function(element) {
                if ($(element).val().trim() === "") {
                    showQuestionFormErrorMessage(element);
                    return false;
                } else {
                    hideQuestionFormErrorMessage(element);
                    return true;
                }
            }

            var showQuestionFormErrorMessage = function(questionTitleElement) {
                $(questionTitleElement).parents(".question-title-component").css("margin-bottom", "4px");
                $(questionTitleElement)
                    .parents(".question-container")
                    .find(".error-message")
                    .css("display", "flex");
            }

            var hideQuestionFormErrorMessage = function(questionTitleElement) {
                $(questionTitleElement)
                    .parents(".question-title-component")
                    .css("margin-bottom", "12px");
                $(questionTitleElement)
                    .parents(".question-container")
                    .find(".error-message")
                    .css("display", "none");
            }

            $scope.showQuestionsTab = function(e) {
                $(e.target).parents('ul.nav').find('a').removeClass('activeitem');
                $(e.target).addClass('activeitem');
                $(".quiz-metadata .empty-state-container").hide();
                $(".detailsTabContent").hide();
                $(".settingsTabContent").hide();

                if ($scope.quiz.questions && $scope.quiz.questions.length) {
                    $(".questionsTabContent").show();
                } else {
                    $(".empty-state-container").show();
                }
            }

            $scope.showDetailsTab = function(e) {
                $(".quiz-metadata .empty-state-container").hide();
                $(e.target).parents('ul.nav').find('a').removeClass('activeitem');
                $(e.target).addClass('activeitem');
                $(".settingsTabContent").hide();
                $(".questionsTabContent").hide();
                $(".detailsTabContent").show();
            }

            $scope.showSettingsTab = function(e) {
                $(".quiz-metadata .empty-state-container").hide();
                $(e.target).parents('ul.nav').find('a').removeClass('activeitem');
                $(e.target).addClass('activeitem');
                $(".detailsTabContent").hide();
                $(".questionsTabContent").hide();
                $(".settingsTabContent").show();
            }

            $scope.handleQuestionCardMenuIconClick = function(e) {
                $(e.target).parents(".question-card").find(".view-answers-menu").toggle();
            }

            $scope.handleChangeActiveViewClick = function(e, playerSide) {
                if (playerSide === "left") {
                    $(".player-quiz-tabs-container").css("flex-direction", "row");

                    if( !$(e.target).hasClass('selected') ) {
                        $(e.target).addClass('selected');
                    }

                    //remove selected from right
                    var rightIcon = $(e.target).parent().find('div:nth-child(2)');
                    if( $(rightIcon).hasClass('selected') ) {
                        $(rightIcon).removeClass('selected');
                    }
                }

                if (playerSide === "right") {
                    if( !$(e.target).hasClass('selected') ) {
                        $(e.target).addClass('selected');
                    }

                    var leftIcon = $(e.target).parent().find('div:nth-child(1)');
                    if( $(leftIcon).hasClass('selected') ) {
                        $(leftIcon).removeClass('selected');
                    }

                    $(".player-quiz-tabs-container").css("flex-direction", "row-reverse");
                }
            }

            $scope.handleCardViewAnswersClick = function(e) {
                $(e.target).parents(".question-card").find(".answers-container").toggle();

                var element;
                if($(e.target).hasClass('view-answers')) {
                    element = $(e.target);
                } else {
                    element = $(e.target).parents(".view-answers");
                }

                if ($(element).find(".chevron-down").css("transform").indexOf("matrix") > -1) {
                    $(element).find(".chevron-down").css("transform", "");
                } else {
                    $(element).find(".chevron-down").css("transform", "rotate(180deg)");
                }
            }

            $scope.handleQuestionCounterClick = function() {
                //hide take quiz
                $('.take-quiz-metadata-container').hide();
                //show question
                $('.take-quiz-answer-question').show();
            }

            $('body').on('click', function(e){

                var menuCandidate = $(e.target).hasClass('overflow-menu');

                if(!menuCandidate) {
                    menuCandidate = $(e.target).parents('.overflow-menu').length;
                }

                if(!menuCandidate) {
                    menuCandidate = $(e.target).hasClass('menu-button');
                }

                if(!menuCandidate) {
                    menuCandidate = $(e.target).parents('.menu-button').length;
                }

                if(!menuCandidate) {
                    $('.overflow-menu').hide();
                }
            });

            $scope.checkEnterKey = function(e) {
                if(e.key === 'Enter') {
                    e.preventDefault();
                    $(e.target).click();
                }
            }

            $scope.handleQuestionAnswerFeedbackButtonClick = function(type) {
                setTimeout(function() {
                    $('#' + type + 'FeedbackModal textarea').focus();
                }, 500);
            }

            $scope.handleAnswerInputKeyDown = function(e) {
                setTimeout(function() {
                    if($(e.target).val() === '') {
                        $(e.target).parent().css('background', '#f2f3f5');
                    } else {
                        $(e.target).parent().css('background', '#fff');
                    }
                }, 0);
            }

            $scope.handleSaveQuizButtonClick = function() {
                var newQuiz = {
                    id: 1,
                    title: $('.quiz-metadata-container .quiz-field-container input').val(),
                    description: $('.quiz-metadata-container .quiz-field-container textarea').val(),
                    createdOn: Date(),
                    createdBy: 'John Doe',
                    lastEdited: Date(),
                    parentAsset: '',
                    questions: $scope.quiz.questions
                }

                $scope.quiz = newQuiz;

                console.log('$scope.quiz', $scope.quiz)
            }

            $scope.handleDeleteQuestionClick = function(question) {
                var questionIndex = $scope.quiz.questions.findIndex(q => q.id === question.id);
                $scope.quiz.questions.splice(questionIndex, 1);
            }

            $scope.handleSettingsSwitchClick = function(e) {
                var switchId = $(e.target).attr('id');

                if(!$scope.quiz.settings)
                    $scope.quiz.settings = {};

                eval('$scope.quiz.settings.' + switchId + ' = ' + $(e.target)[0].checked);
            }

            var waitForElement = function(selector, callback) {
                var intervalId = setInterval(function(){
                    if($(selector).length) {
                        clearInterval(intervalId);
                        callback();
                    }
                }, 50);
            }

            var focusOnQuizTitleInput = function() {
                waitForElement('.quiz-metadata-container  input[type=text]', function(){
                    $('.quiz-metadata-container  input[type=text]').focus();
                })
            }

            focusOnQuizTitleInput();
        });
    });
